

import { useQuery } from "@tanstack/react-query";
import type { AdminView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useProfileQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.profile(),
    queryFn: () => apiJsonClient<AdminView>(endpoints.admin.profile),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    // A retry after a failed load: the error state shows it is under way.
    isRefetching: query.isRefetching,
  };
}
